export const type = 'form.colorGradientPicker';
